module.exports = __webpack_public_path__ + "img/9cf04c2.jpg";